import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { seguridadDAModulo } from 'src/app/aplicaciones-modulos/seguridadDA/diccionarios/seguridadDAModule';

@Injectable({
  providedIn: 'root'
})
export class CaracteristicaService {

  diccionarioUrl: any;
  urlUniforme: string;
  
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getUniforme();
    //this.urlUniforme = "http://localhost:8080/nomina-api/v1/api/services/";

    this.diccionarioUrl = seguridadDAModulo.url.seguridad;
  }

  getAllDepartamento() {
    return this.commom.peticionGetConHeader(this.urlUniforme + 'caracteristica/departamento');
  } 

  getAllLocalidad() {
    return this.commom.peticionGetConHeader(this.urlUniforme + 'caracteristica/localidad' );
  } 

  getAllEmpleado() {
    return this.commom.peticionGetConHeader(this.urlUniforme + 'empleado/');
  } 

  findEmpleadoByLocalidad(localidad: string) {
    return this.commom.peticionGetConHeader(this.urlUniforme + 'empleado/' + 'localidad' + '/' + localidad);
  } 
  
  findEmpleadoByDepartamento(departamento: string) {
    return this.commom.peticionGetConHeader(this.urlUniforme + 'empleado/' + 'departamento' + '/' + departamento);
  } 

  findEmpleadoByDepLoc(departamento: string, localidad: string) {
    return this.commom.peticionGetConHeader(this.urlUniforme + 'empleado/' + 'depaLocalidad' 
        + '/' + departamento +'/'+ localidad);
  } 

  sincroDa(area: string, localidad: string, empleado: string){
    return this.commom.peticionPostConHeader(this.urlUniforme + 'syncDA/updateInfo' + '/' + area 
        + '/' + localidad +'/'+ empleado, null);
  }
  
  getSyncStatus() {
    return this.commom.peticionGetConHeader(this.urlUniforme + 'syncStatus');
  }

  sincroDAUbitsCreateIndividual(empleado: any){
    const url = this.urlUniforme + 'syncDA/crear/employee';
    return this.commom.peticionPostConHeader(url, empleado);
  }

  sincroDAUbitsCreateLoteArea(area, localidad, cedula){
    const url = this.urlUniforme + 'syncDA/crear/lote/area/'+area+'/'+localidad+'/'+cedula;
    return this.commom.peticionPostConHeader(url, "");
  }

  sincroDAUbitsCreateLote(){
    const url = this.urlUniforme + 'syncDA/crear/lote';
    return this.commom.peticionPostConHeader(url, "");
  }


}
